import React from 'react';
import $ from 'jquery';
import * as _ from 'lodash';
import uuid from 'uuid';
import PropTypes from 'prop-types';

import ProjectScope from './../projectScope/projectScope';
import StonesStore from './../../stores/stonesStore';
import ActionTypes from './../../actionTypes';
import * as Misc from './../../misc';
import FilterContentHolder from './filterContentHolder';
import CustomerView from './customerView';
import MessageBox from './../common/messageBox/messageBox';
import OnScreenKeyboard from './../OnScreenKeyboard/keyboard';
import Middleware from './../../middleware';
import FilterMaterialItem from './filterMaterialItem';
import FilterColorItemWithText from './filterColorItemWithText';
import StoneItem from './stoneItem';
import IntroVideo from './../common/introVideo';
import Analytics from './../../analytics';
import LazyLoad, { forceCheck } from 'react-lazyload';
import Config from './../../config';
import TwoFactorAuthentication from './twoFactorAuthView';

const FILTER_GROUPS = StonesStore.FILTER_GROUPS;

const groupHeaderNames = {
  'quartz': true
};

const childItemNames = {
  'silestone': 'quartz',
  'dekton': 'quartz',
  // 'quartzite': 'quartz',
  'ceasarstone': 'quartz',
  'caesarstone': 'quartz',
  // 'sensa': 'quartz',
  'textured': 'quartz',
  'cambria': 'quartz',
  'eco': 'quartz',
  'recycled glass': 'quartz',
  'geos': 'quartz',
  'hanstone': 'quartz',
  'icestone': 'quartz',
  'lg viatera': 'quartz',
  'msi': 'quartz',
  'pental': 'quartz',
  'zodiaq': 'quartz',
  'metroquartz': 'quartz',
  'della terra': 'quartz',
  'cimstone': 'quartz',
  'zodiac': 'quartz',
  'spectrum': 'quartz'
};

export default class StonesView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      searchInputOpened: '',
      sr: null,
      color: '',
      type: [],
      sortBy: 'price',
      filterColorVisible: false,
      filterMaterialsVisible: false,
      customerViewVisible: false,
      goToNextView: false,
      isMessageBoxVisible: false,
      messageBoxText: '',
      searchTextFieldId: uuid.v4(),
      pendingStone: null,
      currentIntroVideo: !ProjectScope.shownIntroVideos('lockedStone') ? '#lockedStone' : null,
      filterMaterialGroupItems: {},
      isMobile: this.mobilecheck(),
      waitOrientation: false,
      assignedOrientationFunction: false,
      onMountSelectedStone: null
    };
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
    $(document).on('stopVideos', this.handleClickWhenIntroVideo);

    const router = this.context.router;
    const route = this.props.route;
    router.setRouteLeaveHook(route, this.routeWillLeave);

    // set 4th stone selected if user not logged in

    const quoteStone = ProjectScope.quote().stone;
    const userInfo = ProjectScope.userInfo();
    const isUserLogged = userInfo && userInfo.email !== '';
    if (!quoteStone && !isUserLogged) {
      ProjectScope.setStone(this.getFilteredStones()[3]);
    } else {
      if (!isUserLogged) {
        this.setState({
          onMountSelectedStone: quoteStone
        })
      }
    }

    this.animateStones(ProjectScope.stonesViewFirstTimeView());

    $(document).click(event => {
      if (!this.state.filterColorVisible && !this.state.filterMaterialsVisible) {
        return;
      }
      if ($(event.target).is('.stone-filter-button-icon')) {
        return;
      }

      if (!$(event.target).closest('#filter-content-holder').length && !$(event.target).is('#filter-content-holder')) {
        this.setState({
          filterColorVisible: false,
          filterMaterialsVisible: false
        });
      }
    });

    if (!ProjectScope.shownIntroVideos('lockedStone')) {
      ProjectScope.setShownIntroVideos('lockedStone', true);
      Misc.playVideo('#lockedStone', () => this.subscribeToDocumentClick('#lockedStone'));
    }

    // console.log('this.props.location.query.stoneId', this.props.location.query && this.props.location.query.stoneId);

    this.scrollToStone();

    document.setStoneFromIframeStonesPage = (data) => {
      let stone = data.quote.stone && StonesStore.stoneById(data.quote.stone.Id);
      data.quote.stone && (data.quote.stone.Id !== 8472) && ProjectScope.setStone(stone);
      ProjectScope.setFeaturesToDisplay(data.quote.features); // show new features in iframe, but do not change in the list
      this.scrollToStone();
    };

    $(".main-wrapper").on('scroll', () => {
      if (this.state.isMobile || Config.kioskStandAlone) {
        this.lazyLoaderForceCheck();
      }
    });
    if(Config.kioskStandAlone) this.lazyLoaderForceCheck();
    // this.handleOrientationChange();

    $(document).on('show-phone-validation', () => this.setState({showTwoFactor: true}));
  }

  handleOrientationChange =() => {
    this.setState({
        waitOrientation: true
    }, () => {
        setTimeout(() => {
            this.setState({
                waitOrientation: false,
                assignedOrientationFunction: false
            });
            $(window).off('resize', this.handleOrientationChange);
        }, 300)
    })
  };

  componentDidUpdate() {
    //this.animateStones(false);
    this.state.searchInputOpened && this.nameInput.focus();
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
    this.handleClickWhenIntroVideo();
    $(document).off('click', this.handleClickWhenIntroVideo);
    $(document).off('show-phone-validation');
  }

  componentWillReceiveProps(nextProps) {
      if (nextProps.switchToKV && !this.state.assignedOrientationFunction) {
          this.setState({
              assignedOrientationFunction: true
          }, () => {
              $(window).on('resize', this.handleOrientationChange);
          });
      }
  }

  subscribeToDocumentClick = (video) => {
    this.state.currentIntroVideo = video;
    $(document)
      .off('click', this.handleClickWhenIntroVideo)
      .on('click', this.handleClickWhenIntroVideo);
  };

  handleClickWhenIntroVideo = () => {
    if (this.state.currentIntroVideo) {
      Analytics.sendClickEvent('stones-hide-video-' + this.state.currentIntroVideo);
      Misc.hideVideo(this.state.currentIntroVideo);
      this.state.currentIntroVideo = null;
      $(document).off('click', this.handleClickWhenIntroVideo);
    }
  };

  showCustomerPopupVideo = () => {
    if(this.state.currentIntroVideo === "#lockedStone")
      this.handleClickWhenIntroVideo();

    if (!ProjectScope.shownIntroVideos('customerPopup')) {
      ProjectScope.setShownIntroVideos('customerPopup', true);
      Misc.playVideo('#customerPopup', () => this.subscribeToDocumentClick('#customerPopup'));
    }
  };

  routeWillLeave = (nextLocation) => {
    if (nextLocation.pathname === '/summary') {
      if (!ProjectScope.quote().stone) {
        this.setState({isMessageBoxVisible: true, messageBoxText: 'Please select a stone.'});
        return false;
      }

      if (!ProjectScope.userInfo()) { // not logged in
        this.setState({customerViewVisible: true, goToNextView: true});
        this.handleClickWhenIntroVideo();
        this.showCustomerPopupVideo();
        return false;
      }
    }
  };

  handleQuoteDataChanged = () => {
    this.forceUpdate();
  };

  handleSearchTextChanged = (e) => {
    Analytics.sendDataEnteredEvent('stone-search-text-changed');
    this.setState({
      searchText: e.target.value,
      sr: e.target.value !== '' ? new RegExp(e.target.value, 'i') : null
    }, this.lazyLoaderForceCheck);
  };

  handleInputFocus = () => {
    Config.isAndroid() && $('.app-container').addClass('app-container--android');
  };

  handleInputBlur = () => {
    $('.app-container').removeClass('app-container--android');
  };

  setSearchFieldValue = (value) => {
    this.setState({
      searchText: value,
      sr: value !== '' ? new RegExp(value, 'i') : null
    }, this.lazyLoaderForceCheck);
  };

  handleToggleSorting = (e) => {
    Analytics.sendDataEnteredEvent('stone-sort-changed');
    Misc.ignoreDefault(e);
    this.setState({
      sortBy: this.state.sortBy === 'price' ? 'name' : 'price',
      filterColorVisible: false,
      filterMaterialsVisible: false,
      searchInputOpened: false
    }, this.lazyLoaderForceCheck);
    this.nameInput.blur();
    $(document).off('click', this.checkIfSearchOpened);
  };

  handleFilterColorsClick = (e) => {
    Analytics.sendClickEvent('stone-filter-colors');
    Misc.ignoreDefault(e);
    this.setState({
      filterColorVisible: !this.state.filterColorVisible,
      filterMaterialsVisible: false,
      searchInputOpened: false
    });
    this.nameInput.blur();
    $(document).off('click', this.checkIfSearchOpened);
  };

  handleFilterMaterialsClick = (e) => {
    Analytics.sendClickEvent('stone-material-colors');
    Misc.ignoreDefault(e);
    this.setState({
      filterColorVisible: false,
      searchInputOpened: false,
      filterMaterialsVisible: !this.state.filterMaterialsVisible
    });
    this.nameInput.blur();
    $(document).off('click', this.checkIfSearchOpened);
  };

  handleFilterColorsItemClick = (color) => {
    Analytics.sendClickEvent('stone-filter-color');
    this.setState({color: color}, this.lazyLoaderForceCheck);
  };

  handleFilterMaterialItemClick = (material, type = '', items = null) => {
    let i;
    Analytics.sendClickEvent('stone-filter-material');
    const {filterMaterialGroupItems} = this.state;
    const ar = this.state.type;
    if (type === 'groupHeader') {
      if(typeof filterMaterialGroupItems[material.toLowerCase()] === 'undefined') {
        filterMaterialGroupItems[material.toLowerCase()] = {isExpanded: false};
      }
      filterMaterialGroupItems[material.toLowerCase()].isExpanded = !filterMaterialGroupItems[material.toLowerCase()].isExpanded;
      if(!filterMaterialGroupItems[material.toLowerCase()].isExpanded) {
        for(const item in items) {
          i = ar.indexOf(items[item].Value);
          if(i !== -1) {
            ar.splice(i, 1);
          }
        }
      }
    }
    if (type === 'subItem') { //3rd argument is parent item in this case, parent item needs to be de-selected if children are selected
      i = ar.indexOf(items.Value);
      if(i !== -1) {
        ar.splice(i, 1);
      }
    }
    const index = ar.indexOf(material);
    if (index === -1) {
      ar.push(material);
    } else {
      ar.splice(index, 1);
    }
    this.setState({type: ar, filterMaterialGroupItems: filterMaterialGroupItems}, this.lazyLoaderForceCheck);
  };

  handleFilterColorsButtonClick = (type) => {
    Analytics.sendClickEvent('stone-filter-colors');
    this.setState({
      filterColorVisible: false,
      color: type === 'reset' ? '' : this.state.color
    });
  };

  handleFilterMaterialButtonClick = (type) => {
    Analytics.sendClickEvent('stone-filter-materials');
    this.setState({
      filterMaterialsVisible: false,
      type: type === 'reset' ? [] : this.state.type,
      filterMaterialGroupItems: type === 'reset' ? {} : this.state.filterMaterialGroupItems
    });
  };

  checkIfSearchOpened = (event) => {
    if (!$(event.target).closest('.stone-filter-button--search').length && !$(event.target).closest('.stone-filter-button-icon').length) {
      this.handleOpenSearchClick();
    }
  };

  handleOpenSearchClick = () => {
    this.setState({
      searchInputOpened: !this.state.searchInputOpened,
      filterColorVisible: false,
      filterMaterialsVisible: false
    }, () => {
      if (this.state.searchInputOpened) {
        setTimeout(()=> {
          $(document).on('click', this.checkIfSearchOpened);
          if(Config.kioskStandAlone) {
            window.setTimeout(() => {
              this.nameInput.blur();
              this.nameInput.focus();
            }, 300);
          }
        },0)
      } else {
        this.nameInput.blur();
        $(document).off('click', this.checkIfSearchOpened);
      }
    });
  };

  handleStoneClick = (stone, isLocked) => {
    Analytics.sendClickEvent('stone');
    if (!isLocked) {
      ProjectScope.setStone(stone);
    } else {
      const userInfo = ProjectScope.userInfo();
      if(userInfo && userInfo.email && userInfo.email.length > 0 && !userInfo.isPhoneNumberValidated && !ProjectScope.isBackend) {
        this.setState({showTwoFactor: true, goToNextView: false, pendingStone: stone});
      } else {
        this.setState({customerViewVisible: true, goToNextView: false, pendingStone: stone});
      }
      this.handleClickWhenIntroVideo();
      this.showCustomerPopupVideo();
    }
  };

  handleUserAuthenticated = (registered = false) => {
    let userInfo = ProjectScope.userInfo();
    if (registered && this.state.goToNextView) {
      Middleware.saveQuote(false);
      // if user clicked before on the Next button, go to Summary after authentication
      this.state.goToNextView = false;
      this.context.router.push('/summary');
      return;
    }

    if (this.state.pendingStone) {
      ProjectScope.setStone(this.state.pendingStone);
      Middleware.saveQuote(false);
      this.state.pendingStone = null;
    }
    // this will happen when user clicks on a locked stone, just hide the dialog
    this.setState({customerViewVisible: false});
    this.animateStones(false);

    if(registered && !Config.kioskStandAlone && !userInfo.isPhoneNumberValidated && !ProjectScope.isBackend) {
      this.setState({showTwoFactor: true});
    }
  };

  handleVerficationClose = (cancel = true, updatePhone = null) => {
    if(cancel) {
      this.setState({showTwoFactor: false});
      return;
    }
    let userInfo = ProjectScope.userInfo();
    if(updatePhone && updatePhone !== userInfo.phoneNumber) {
      userInfo.phoneNumber = updatePhone;
      userInfo.isPhoneNumberValidated = true;
      ProjectScope.setUserInfo(userInfo);
    }
    this.setState({showTwoFactor: false}, () => {
      if(this.state.goToNextView) {
        Middleware.saveQuote(false);
        // if user clicked before on the Next button, go to Summary after authentication
        this.state.goToNextView = false;
        this.context.router.push('/summary');
      }
    });
  }

  handleCustomerViewHide = () => {
    this.setState({customerViewVisible: false});
  };

  animateStones = (onlyFirst) => {
    if (!StonesStore.stonesLoaded()) {
      return null;
    }

    if (onlyFirst) {
      if (ProjectScope.stonesViewFirstTimeView()) {
        ProjectScope.stonesViewFirstTimeView(false);
        setTimeout(() => {
          $('.initialStone1').addClass('animation01');
          $('.initialStone2').addClass('animation02');
          $('.initialStone3').addClass('animation03');
        }, 250);
      }
    } else {
      if (ProjectScope.stonesViewFirstTimeCustomerLogin()) {
        ProjectScope.stonesViewFirstTimeCustomerLogin(false);

        setTimeout(() => {
          $('.nonInitialStone').addClass('animation-long');
        }, 250);
      }
    }
  };

  ignoreTags = {"tile": true, "tile_4in": true, "tile_f": true};
  filterGroups = StonesStore.getFilterGroups();
  parseStoneTags = (filteredStones) => {
    const colors = [];
    const types = [];

    _.forEach(filteredStones, (s) => {
      /*_.forEach(s.TagList, (tag) => {
        tag = tag.toLowerCase().trim();
        if (tag.length && !this.ignoreTags[tag]) {
          if (Colors.isColor(tag)) {
            if (colors.indexOf(tag) === -1) {
              colors.push(tag);
            }
          } else {
            if (types.indexOf(tag) === -1) {
              types.push(tag);
            }
          }
        }
      });*/
      
      _.forEach(s.FilterValueIDs, (id) => {
        let colorFilter = this.filterGroups[FILTER_GROUPS.COLOR].Values.filter(v => v.Id == id);
        //let materialFilter = this.filterGroups[FILTER_GROUPS.MATERIAL].Values.filter(v => v.Id == id);
        if(colorFilter.length > 0) {
          var existingIndex = _.findIndex(colors, c => c.toLowerCase().trim() === colorFilter[0].Value.toLowerCase().trim());
          if(existingIndex == -1) {
            colors.push(colorFilter[0].DisplayText.toLowerCase());
          }
        }/* else if(materialFilter.length > 0) {
          var existingIndex = _.findIndex(types, c => c.toLowerCase().trim() === materialFilter[0].Value.toLowerCase().trim());
          if(existingIndex == -1) {
            types.push(materialFilter[0].Value.toLowerCase());
          }
        }*/
      });
    });

    return {colors: colors, types: types};
  };

  hasFilter = (stone, filterGroup, filterValues) => {
    if(typeof(filterValues) !== 'object') {
      filterValues = [filterValues];
    }
    let flatFilters = [];
    for(let i = 0; i < this.filterGroups[filterGroup].Values.length; i++) {
      let filterValue = this.filterGroups[filterGroup].Values[i];
      flatFilters.push(filterValue);
      if(filterValue.Items && filterValue.Items.length > 0) {
        for(let n = 0; n < filterValue.Items.length; n++) {
          flatFilters.push(filterValue.Items[n]);
        }
      }
    }

    let filter = flatFilters.filter((n) => { 
      for(let i = 0; i < filterValues.length; i++) {
        const filterValue = filterValues[i];
        if((filterGroup === FILTER_GROUPS.COLOR ? n.DisplayText.toLowerCase().trim() : n.Value.toLowerCase().trim()) === filterValue.toLowerCase().trim()) {
          return true;
        }
      }
      return false;
    });
    
    if(filter.length > 0) {
      let filterIds = _.map(filter, f => f.Id);
      return _.intersection(stone.FilterValueIDs, filterIds).length > 0;
    }
  };

  handleMessageBoxOkClick = () => {
    this.setState({isMessageBoxVisible: false});
  };

  render() {
    if (!StonesStore.stonesLoaded()) {
      return null;
    }

    let colorsAndTypes = null;
    const stones = this.renderStones(function (ct) {
      colorsAndTypes = ct;
    });

    let userInfo = ProjectScope.userInfo();

    return (
      <div className="content-wrapper">
        <IntroVideo type="customerPopup"/>
        <IntroVideo type="lockedStone"/>
        {this.state.isMessageBoxVisible ?
          <MessageBox message={this.state.messageBoxText} click={this.handleMessageBoxOkClick}
                      error={true}/> : null}
          <CustomerView view="register" userAuthenticated={this.handleUserAuthenticated}
                          hideOverlayVideo={this.handleClickWhenIntroVideo}
                          hide={this.handleCustomerViewHide} visible={this.state.customerViewVisible}/>
        {this.renderFilters(colorsAndTypes.colors, colorsAndTypes.types)}
        <div className="flex-container">
          {!this.state.waitOrientation ? stones : null}
        </div>
        {this.state.showTwoFactor ? <TwoFactorAuthentication 
          phoneNumber={userInfo.phone}
          onClose={this.handleVerficationClose}
        /> : null}
      </div>
    );
  };

  scrollToStone =() => {

    const quoteStone = ProjectScope.quote().stone;

    if (quoteStone) {

      let selectedStone = null;

      if (this.state.isMobile || Config.kioskStandAlone) {
        selectedStone = [].slice.call($('.step2Placeholder')).filter((stone)=>{
          return +$(stone).attr('data-id') === quoteStone.Id
        });
      }
      if(!selectedStone) {
        selectedStone = [].slice.call($('.step2Cont')).filter((stone)=>{
          return +$(stone).attr('data-id') === quoteStone.Id
        });
      }

      const $wrapper = $(".main-wrapper"),
            $selectedStone = $(selectedStone);

      $wrapper.scrollTop(0);  // set initial position

      setTimeout(() => {
        if($selectedStone.offset()) {
          $wrapper.animate({
            scrollTop: $selectedStone.offset().top - ($wrapper.height() / 2) - $selectedStone.height()/2
          }, 1000);
        }
      }, 500);

    } else {
      this.props.isDocked() && $('.header-bar').addClass('header-bar-docked'); // if we don't have selected stone, we still need to check if header needs docked class
    }

  };

  mobilecheck = () => {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  getFilteredStones = (cb) => {
    const noPriceStoneId = StonesStore.noPriceStoneId();
    let filteredStones = _.filter(StonesStore.supportedStones(), s => s.Id !== noPriceStoneId);

    if (this.state.sr) {
      filteredStones = _.filter(filteredStones, s => {
        return this.state.sr.test(s.Name) || (s.Description && this.state.sr.test(s.Description))
          || _.some(s.TagList, tag => this.state.sr.test(tag));
      });
    }

    // parse tags
    filteredStones = _.uniqBy(filteredStones, 'Id');

    if (cb) {
      let colorsAndTypes = this.parseStoneTags(filteredStones);
      cb(colorsAndTypes);
    }

    if (this.state.color || this.state.type.length) {
      filteredStones = _.filter(filteredStones, s => {
        const tagList = s.TagList.map(tag => tag.toLowerCase());
        return ((!this.state.color || this.hasFilter(s, FILTER_GROUPS.COLOR, this.state.color)) &&
          (this.state.type.length === 0 || this.hasFilter(s, FILTER_GROUPS.MATERIAL, this.state.type)));
      });
    }

    if (this.state.sortBy === 'price') {
        filteredStones = _.orderBy(filteredStones, s => s.prices[0], ['asc']);
    } else if (this.state.sortBy === 'name') {
        filteredStones = _.sortBy(filteredStones, ['Name'], ['desc']);
    }

    return filteredStones

  };

  renderStones = (cb) => {
    const userInfo = ProjectScope.userInfo();
    const isUserLogged = userInfo && userInfo.email !== '' && (userInfo.isPhoneNumberValidated || ProjectScope.isBackend);
    const quoteStone = ProjectScope.quote().stone;
    const filteredStones = this.getFilteredStones(cb);
    const unlockedStones = ProjectScope.unlockedStones();
    let onMountSelectedIndex = 0;

    let stonesItemsArray = filteredStones.map((stone, index) => {
      let isStoneLocked = false;
      let initialStoneIndex = 0;
      if (!ProjectScope.isBackend) {
        initialStoneIndex = unlockedStones.indexOf(stone.Id);
        isStoneLocked = !isUserLogged && initialStoneIndex === -1;
      } else {
        isStoneLocked = false;
      }

      const key = stone.Id + "_" + filteredStones.indexOf(stone);
      const validPrice = stone.prices.length > 0;

      if(!validPrice) {
        return null;
      }

      const isSelected = quoteStone && quoteStone.Id === stone.Id;

      if (this.state.onMountSelectedStone && this.state.onMountSelectedStone.Id === stone.Id) {
        onMountSelectedIndex = index;
      }
      
      let stoneItem = <StoneItem stone={stone} isLocked={isStoneLocked} isSelected={isSelected}
                     click={this.handleStoneClick} initialStoneIndex={initialStoneIndex} key={key}/>;

      if(this.state.isMobile) {
        return (
          <LazyLoad height={225} offset={450} unmountIfInvisible={true}
                    placeholder={<div className="step2Placeholder" data-id={stone.Id}/>} key={key}>
            {stoneItem}
          </LazyLoad>
        );
      } else if(Config.kioskStandAlone) {
        return (
          <LazyLoad height={225} offset={2250} unmountIfInvisible={true}
                    placeholder={<div className="step2Placeholder" data-id={stone.Id}/>} key={key}>
            {stoneItem}
          </LazyLoad>
        );
      }
      return stoneItem;
    });
    if (onMountSelectedIndex) {
      stonesItemsArray.splice(3, 0, stonesItemsArray.splice(onMountSelectedIndex, 1)[0]);  // cut selected stone & place it to #4 (http://jira.mozidev.com/browse/QC-724)
    }
    return stonesItemsArray
  };

  lastPosition = 0;

  lazyLoaderForceCheck = _.debounce(forceCheck, 300);

  renderFilters = (colors, materials) => {
    let materialText = '';
    if (this.state.type.length === 1) {
      materialText = this.state.type[0];
    } else if (this.state.type.length > 1) {
      materialText = 'Multiple';
    }
    return (
      <div className="stone-filters-wrapper">
        <div className="stone-filter">
          <div className="stone-filter-button">
            <div className={"stone-filter-button-title " + ((materialText !== '') ? "stone-filter-button-title--active" : "")}>
              {(materialText !== '') ? materialText : "Material"}</div>
            <div className="stone-filter-button-icon stone-filter-button-icon--material" onClick={this.handleFilterMaterialsClick}>
              {this.state.filterMaterialsVisible ? this.renderFilterMaterials(materials) : null}
            </div>
          </div>
          <div className="stone-filter-button">
            <div className={"stone-filter-button-title " + ((this.state.color !== '') ? "stone-filter-button-title--active" : "")}>
              {this.state.color !== '' ? this.state.color : "Color"}</div>
            <div className="stone-filter-button-icon stone-filter-button-icon--color" onClick={this.handleFilterColorsClick}>
              {this.state.filterColorVisible ? this.renderFilterColors(colors) : null}
            </div>
          </div>
          <div className="stone-filter-button" onClick={this.handleToggleSorting}>
            <div className="stone-filter-button-title">{this.state.sortBy}</div>
            <div className={"stone-filter-button-icon stone-filter-button-icon--"+this.state.sortBy}/>
          </div>
          <div className="stone-filter-button stone-filter-button--search">
            <div className={"stone-filter-button-title " + ((this.state.searchText !== '') ? "stone-filter-button-title--active" : "")}>
              Search</div>
            <div className="stone-filter-button-icon stone-filter-button-icon--search" onClick={this.handleOpenSearchClick}/>
            <input value={this.state.searchText} type="Search" onChange={this.handleSearchTextChanged}
                   onFocus={this.handleInputFocus} onBlur={this.handleInputBlur}
                   className={"stone-search-box "+(this.state.searchInputOpened ? "stone-search-box--opened" : "")}
                   ref={(input) => { this.nameInput = input; }} id={this.state.searchTextFieldId}/>
            <OnScreenKeyboard title="Search Filter" inputId={this.state.searchTextFieldId}
                              setValue={this.setSearchFieldValue} top="100px" left="250px"/>
          </div>
        </div>
      </div>
    );
  };

  renderFilterColors = (colors) => {
    const items = _.orderBy(colors).map(color => {
      const isSelected = color === this.state.color;
      return (
        <FilterColorItemWithText isSelected={isSelected} color={color} click={this.handleFilterColorsItemClick}
                                 key={color}/>);
    });

    return (
      <FilterContentHolder items={items}
                           acceptClick={this.handleFilterColorsButtonClick}
                           resetClick={this.handleFilterColorsButtonClick}/>
    );
  };

  renderFilterMaterials = (materials) => {
    var materialFilters = this.filterGroups[FILTER_GROUPS.MATERIAL].Values
    const groupedItems = [];
    materialFilters = _.orderBy(materialFilters, _ => _.Value.toLowerCase());
    _.forEach(materialFilters, m => {
      var isSelected = this.state.type.indexOf(m.Value) !== -1;
      var anyChildren = false;
      var isExpanded = this.state.filterMaterialGroupItems[m.Value.toLowerCase()] ? this.state.filterMaterialGroupItems[m.Value.toLowerCase()].isExpanded : false;
      groupedItems.push({
        ...m,
        isSelected,
        isExpanded
      });
    });

    _.forEach(groupedItems, groupItem => {
      _.forEach(groupItem.Items, item => {
        item.isSelected = this.state.type.indexOf(item.Value) !== -1
      });
    });

    const items = groupedItems.map(item => {
      return (
        <FilterMaterialItem item={item} key={item.Id}
                            click={this.handleFilterMaterialItemClick}/>
      );
    });

    return (
      <FilterContentHolder items={items}
                           acceptClick={this.handleFilterMaterialButtonClick}
                           resetClick={this.handleFilterMaterialButtonClick}/>
    );
  };
};




// WEBPACK FOOTER //
// ./src/components/stones/stonesViews.js